import { render, staticRenderFns } from "./UserReport.vue?vue&type=template&id=64c3f840&scoped=true"
import script from "./UserReport.vue?vue&type=script&lang=js"
export * from "./UserReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c3f840",
  null
  
)

export default component.exports